module.exports = __webpack_public_path__ + "img/ClosePurple.38f5f6b8.svg";